import React from "react";

import { BeMappedNode } from "src/constants/NodeDataTypes";
import { NODE_TYPE } from "src/constants/NodeTypes";
import { DeletionInfo } from "src/nodeEditor/useSplitNodeSuggestion";
import { SplitBranchDeletionModal } from "src/splitNodeEditor/SplitBranchDeletionModal";

type Props = {
  node: BeMappedNode;
  isOpen: boolean;
  deletionInfo: DeletionInfo | null;
  onConfirmDelete: () => void;
  onCancelDelete: () => void;
};

export const DeletionModal: React.FC<Props> = ({
  node,
  isOpen,
  deletionInfo,
  onConfirmDelete,
  onCancelDelete,
}) => {
  // Only render when there's actual deletion happening
  if (!isOpen || !deletionInfo) {
    return null;
  }

  // Handle split node branch deletion
  if (
    node.type === NODE_TYPE.SPLIT_NODE_V2 &&
    deletionInfo.type === "split-node-branch"
  ) {
    return (
      <SplitBranchDeletionModal
        {...deletionInfo.data}
        branchToDeleteName={deletionInfo.data.branchName}
        open={isOpen}
        onClose={onCancelDelete}
        onConfirmDelete={onConfirmDelete}
      />
    );
  }

  // Future: Add other node type deletion modals here
  // if (node.type === NODE_TYPE.SOME_OTHER_NODE && deletionInfo.type === "some-other-type") {
  //   return <SomeOtherDeletionModal ... />;
  // }

  return null;
};
